import AddEmpleado from 'components/empleados/AddEmpleado'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewAddEmpleado = () => {
  return (
    <>
        <Row>
            <Col>
                <AddEmpleado titulo="Alta de empleado"></AddEmpleado>
            </Col>
        </Row>

    </>
  )
}

export default ViewAddEmpleado